import { render, staticRenderFns } from "./balance.vue?vue&type=template&id=3501e2ee"
import script from "./balance.vue?vue&type=script&lang=js"
export * from "./balance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports